import { emailFormatCheck } from "@/utils"

const validateAddParticipantForm = ({ value, key, extraCheck }, setValidFunc) => {
    if (value === "") {
        setValidFunc((prev) => ({ ...prev, [key]: { ...prev[key], status: true }, overall: true }))
        return false
    }
    if (extraCheck === "email") {
        const emailFormatCheckStatus = emailFormatCheck(value)
        if (!emailFormatCheckStatus) {
            setValidFunc((prev) => ({
                ...prev,
                [key]: {
                    ...prev[key],
                    status: true,
                    errorMessage: "Email format is wrong",
                },
                overall: true,
            }))
            return false
        }
    }
    return true
}

export default validateAddParticipantForm
